import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'list'
})
export class ListPipe implements PipeTransform {

  transform (values) {
    if (values) {
      return values.reverse();
    }
  }

}
